module.exports = __webpack_public_path__ + "static/media/fire_sword.b7a6f1b2.png";